mutation MirrorShopifyProductImage($shop: String!, $productId: ID!) {
  mirrored: StreamToolsMirrorShopifyProductImage(shop: $shop, productId: $productId) {
    productId
    title
    priceCents
    linkUrl
    asset {
      assetId
      fileName
      contentType
      sizeBytes
      publicUrl
      createdAt
    }
    assets {
      assetId
      fileName
      contentType
      sizeBytes
      publicUrl
      createdAt
    }
    defaultVariantId
    variantOptionName
    variantOptions {
      id
      label
    }
  }
}
